import Dashboard from '../containers/dashboard'
import CustomerCompanyBatchesManagement from '../containers/customer-company-batches-management'

const CustomerCompanyBatches = () => {
  return (
    <Dashboard>
      <CustomerCompanyBatchesManagement />
    </Dashboard>
  )
}

export default CustomerCompanyBatches
